<div *ngIf="!loading !== null && ordersStat" id="pedidosCont">
    <h2>Pedidos</h2>
    <div id="pedidosNumbers">
        <div id="pedidosLeft">
            <div *ngIf="ordersStat.total_sales_porcent === 0" [style.color]="'#b5cad9'" class="percentage">
                {{ordersStat.total_sales_porcent}}%
            </div>
            <div *ngIf="ordersStat.total_sales_porcent > 0" [style.color]="'rgb(0 201 151)'" class="percentage">
                <img src="assets/img/arrow-green.svg" alt=""/> {{ordersStat.total_sales_porcent}}%
            </div>
            <div *ngIf="ordersStat.total_sales_porcent < 0" [style.color]="'rgb(255 115 115)'" class="percentage">
                <img src="assets/img/arrow-red.svg" alt=""/> {{ordersStat.total_sales_porcent}}%
            </div>
            <div class="monetaryValue">
                {{ordersStat.total_sales | currency: 'pt-br' : 'R$'}}
            </div>
            <div class="detailType">
                Receita
            </div>
        </div>
        <div id="pedidosCenter">
            <span>{{ordersStat.num_orders | number}}</span>
        </div>
        <div id="pedidosRight">
            <div *ngIf="ordersStat.ticket_porcent === 0" [style.color]="'#b5cad9'" class="percentage">
                {{ordersStat.ticket_porcent}}%
            </div>
            <div *ngIf="ordersStat.ticket_porcent > 0" [style.color]="'rgb(0 201 151)'" class="percentage">
                <img src="assets/img/arrow-green.svg" alt=""/> {{ordersStat.ticket_porcent}}%
            </div>
            <div *ngIf="ordersStat.ticket_porcent < 0" [style.color]="'rgb(255 115 115)'" class="percentage">
                <img src="assets/img/arrow-red.svg" alt=""/> {{ordersStat.ticket_porcent}}%
            </div>
            <div class="monetaryValue">
                {{ordersStat.ticket | currency: 'pt-br' : 'R$'}}
            </div>
            <div class="detailType">
                Ticket médio
            </div>
        </div>
    </div>
    <div id="distriGraph">
        <div *ngIf="calcPending > 0" title="{{calcPending.toFixed(2)}}%" class="pedidosMesure" [style.width.%]="calcPending" [style.background]="'rgb(255 191 45)'"></div>
        <div *ngIf="calcSeparation > 0" title="{{calcSeparation.toFixed(2)}}%" class="pedidosMesure" [style.width.%]="calcSeparation" [style.background]="'rgb(38 201 252)'"></div>
        <div *ngIf="calcDeliver > 0" title="{{calcDeliver.toFixed(2)}}%" class="pedidosMesure" [style.width.%]="calcDeliver" [style.background]="'rgb(0 201 151)'"></div>
    </div>
    <div id="distriNumbers">
        <div class="detailNumber">
            <span id="pendentes">{{ordersStat.num_order_pending | number}}</span>
            <p *ngIf="ordersStat.num_order_pending === 0 || ordersStat.num_order_pending === 1">Pendente</p>
            <p *ngIf="ordersStat.num_order_pending > 1">Pendentes</p>
        </div>
        <div class="detailNumber">
            <span id="separacao">{{ordersStat.num_order_separation | number}}</span>
            <p *ngIf="ordersStat.num_order_separation === 0 || ordersStat.num_order_separation === 1">Separação</p>
            <p *ngIf="ordersStat.num_order_separation > 1">Separações</p>
        </div>
        <div class="detailNumber">
            <span id="entrega">{{ordersStat.num_order_delivery | number}}</span>
            <p *ngIf="ordersStat.num_order_delivery === 0 || ordersStat.num_order_delivery === 1">Entrega</p>
            <p *ngIf="ordersStat.num_order_delivery > 1">Entregas</p>
        </div>
    </div>
</div>
